var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicroActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 57C44.464 57 57 44.464 57 29C57 13.536 44.464 1 29 1C13.536 1 1 13.536 1 29C1 44.464 13.536 57 29 57Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7512 35.4805L29.2731 35.5217L29.2947 36.0011C29.295 36.0061 29.2951 36.0111 29.2951 36.0162V38.4925C29.2951 38.6699 29.1499 38.818 28.9655 38.818C28.7811 38.818 28.6359 38.6699 28.6359 38.4925V36.0162L28.6361 36.0041L28.6534 35.5245L28.1749 35.4876C24.0798 35.1717 20.797 32.2924 20.3424 28.6308C20.3205 28.4549 20.4461 28.2906 20.6288 28.2682C20.812 28.2457 20.9748 28.3752 20.9967 28.5516C21.4444 32.1576 24.8794 34.8653 28.9199 34.8653C32.9595 34.8653 36.3952 32.1543 36.843 28.5475C36.8649 28.3711 37.0277 28.2416 37.2109 28.2641C37.3936 28.2866 37.5191 28.4508 37.4973 28.6267C37.0457 32.2634 33.8053 35.1304 29.7512 35.4805ZM28.9655 19.8325C26.859 19.8325 25.1471 21.5323 25.1471 23.6344V26.9362C25.1471 29.0382 26.859 30.738 28.9655 30.738C31.0719 30.738 32.7838 29.0382 32.7838 26.9362V23.6344C32.7838 21.5323 31.0719 19.8325 28.9655 19.8325ZM28.9655 19.1816C31.4407 19.1816 33.443 21.1776 33.443 23.6344V26.9362C33.443 29.393 31.4407 31.3889 28.9655 31.3889C26.4902 31.3889 24.4879 29.393 24.4879 26.9362V23.6344C24.4879 21.1776 26.4902 19.1816 28.9655 19.1816Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroActive);
export default __webpack_public_path__ + "static/media/microActive.91c8c586f7000e65fb4f099e02c98eee.svg";
export { ForwardRef as ReactComponent };